<app-header></app-header>
<div class="appointment-wrapper">  
    <h2 class="heading">Complimentary Financial Plan Consultation</h2>

    <div class="appointment-form">
        <div class="form-container">
            <h3 class="form-heading">Book Your Slot</h3>

            <!-- Reactive Form -->
            <form [formGroup]="appointmentForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="name">Name:</label>
                    <input formControlName="name" id="name" type="text" placeholder="Enter your name" />
                    <div *ngIf="appointmentForm.get('name')?.invalid && appointmentForm.get('name')?.touched" class="error">
                        Name is required.
                    </div>
                </div>

                <div class="form-group">
                    <label for="email">Email:</label>
                    <input formControlName="email" id="email" type="email" placeholder="Enter your email" />
                    <div *ngIf="appointmentForm.get('email')?.invalid && appointmentForm.get('email')?.touched" class="error">
                        A valid email is required.
                    </div>
                </div>

                <div class="form-group">
                    <label for="phone">Phone/WhatsApp No:</label>
                    <input formControlName="phone" id="phone" type="text" placeholder="Enter your phone/WhatsApp number" />
                    <div *ngIf="appointmentForm.get('phone')?.invalid && appointmentForm.get('phone')?.touched" class="error">
                        Phone number is required.
                    </div>
                </div>

                <div class="form-group">
                    <label for="appointmentDate">Requested Appointment Date/Time:</label>
                    <input formControlName="appointmentDate" id="appointmentDate" type="datetime-local" />
                    <div *ngIf="appointmentForm.get('appointmentDate')?.invalid && appointmentForm.get('appointmentDate')?.touched" class="error">
                        Appointment date and time are required.
                    </div>
                </div>

                <div class="schedule-btn">
                    <button type="submit" [disabled]="appointmentForm.invalid" class="btn btn-orange">
                        Schedule Your Free Consultation
                    </button>
                </div>
            </form>

            <!-- Success Message -->
            <div *ngIf="isAppointmentSubmitted" class="thank-you-message animated">
                <h3>Thank you for booking your consultation!   <p>We will get back to you shortly.</p> <span class="smiley"></span></h3>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
